import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, X, Check } from 'lucide-react';
const trustPoints = ['No menthol overload', 'No artificial numbing agents', 'No harsh chemicals', 'No gimmicks'];
export function BodyReliefTrustSection() {
  return <section className="py-8 sm:py-12 bg-white" data-id="element-278">
      <div className="max-w-6xl mx-auto px-4" data-id="element-279">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-8 sm:mb-10" data-id="element-280">
          <div className="inline-flex items-center justify-center w-12 h-12 sm:w-14 sm:h-14 rounded-2xl bg-herbal/10 mb-4" data-id="element-281">
            <ShieldCheck className="w-6 h-6 sm:w-7 sm:h-7 text-herbal" data-id="element-282" />
          </div>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-light text-charcoal mb-3 tracking-tight" data-id="element-283">
            Clean. Controlled. Trusted.
          </h2>
          <p className="text-sm sm:text-base text-charcoal-light max-w-2xl mx-auto font-light" data-id="element-284">
            Just functional botanicals formulated for speed and effectiveness.
          </p>
        </motion.div>

        {/* Grid Layout */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 max-w-4xl mx-auto" data-id="element-285">
          {trustPoints.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="group relative bg-bone border-2 border-bone-dark rounded-xl p-4 sm:p-5 hover:border-herbal/30 transition-all duration-300" data-id="element-286">
              {/* X Icon Background */}
              <div className="absolute top-3 right-3 sm:top-4 sm:right-4 w-8 h-8 sm:w-10 sm:h-10 rounded-full bg-red-50 flex items-center justify-center" data-id="element-287">
                <X className="w-4 h-4 sm:w-5 sm:h-5 text-red-500" strokeWidth={3} data-id="element-288" />
              </div>

              {/* Check Icon */}
              <div className="flex items-start gap-3" data-id="element-289">
                <div className="flex-shrink-0 w-7 h-7 sm:w-8 sm:h-8 rounded-lg bg-herbal/10 flex items-center justify-center" data-id="element-290">
                  <Check className="w-4 h-4 sm:w-5 sm:h-5 text-herbal" strokeWidth={3} data-id="element-291" />
                </div>
                <div className="flex-1 pt-0.5" data-id="element-292">
                  <p className="text-sm sm:text-base font-light text-charcoal leading-relaxed" data-id="element-293">
                    {item}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>

        {/* Bottom Trust Badge */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="mt-8 sm:mt-10 text-center" data-id="element-294">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-herbal/5 border border-herbal/20 rounded-full" data-id="element-295">
            <ShieldCheck className="w-4 h-4 text-herbal" data-id="element-296" />
            <span className="text-xs sm:text-sm font-light text-charcoal" data-id="element-297">
              100% Natural Botanical Formula
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}